import React from "react";

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import ReportBody from "Components/Reports/ReportBody";

const Report = () => {
  return (
    <>
      <Header moduleName={"report"} />
      <ReportBody />
      <Footer />
    </>
  );
};

export default Report;
